import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import { nextSearch } from '../utils/loginRedirect';

const ProtectedRoute = ({ children }) => {

  const { user, loading, isInternalOnly } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to={`/login${nextSearch()}`} replace />;
  }

  // The mobile app is tenant-scoped; an internal user without a customer
  // only has customer management, which lives in the dashboard.
  if (isInternalOnly) {
    window.location.href = '/dashboard/customers';
    return null;
  }

  return children;
};

export default ProtectedRoute;
